export default "__VITE_PUBLIC_ASSET__38f00e9d__"